"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importDefault(require("styled-components"));
var AuthContentHeader = (0, styled_components_1.default)('h1')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  height: 55px;\n  line-height: 55px;\n  text-transform: uppercase;\n  background-color: #d0ccc3;\n  color: ", ";\n  margin: 0;\n  font-size: 20px;\n  border-bottom: 2px solid ", ";\n\n  @media (max-width: ", ") {\n    display: none;\n  }\n"], ["\n  ", ";\n  height: 55px;\n  line-height: 55px;\n  text-transform: uppercase;\n  background-color: #d0ccc3;\n  color: ", ";\n  margin: 0;\n  font-size: 20px;\n  border-bottom: 2px solid ", ";\n\n  @media (max-width: ", ") {\n    display: none;\n  }\n"])), function (props) { return props.theme.mixins.flexCenter; }, function (props) { return props.theme.colors.darkgrey; }, function (props) { return props.theme.colors.lightgrey20; }, function (props) {
    return props.theme.variables.smallestWidthBreakpoint;
});
AuthContentHeader.propTypes = {
    children: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.element,
        prop_types_1.default.node
    ])
};
exports.default = AuthContentHeader;
var templateObject_1;
//# sourceMappingURL=AuthContentHeader.js.map